<script>
	import { language, meditations } from '../stores/settings';
</script>

<template>
	<div>
		<label>Language:
			<select name="language" bind:value={$language}>
				<option value="Latin">🇻🇦 Latin</option>
				<option value="English">🇬🇧 English</option>
				<option value="Polish">🇵🇱 Polish</option>
			</select>
		</label>

		<label>Meditations:
			<select name="meditations" bind:value={$meditations}>
				<option value="None">None</option>
				<option value="English">🇬🇧 English</option>
				<option value="Polish">🇵🇱 Polish</option>
			</select>
	</div>
</template>

<style lang="stylus">
	select
		display block
		padding 0.5rem 2rem
		margin-top 0.5rem
		background black
		color white
		border 1px rgba(white, 0.5) solid
</style>
